




































































import { Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import ClientOnly from 'vue-client-only';
import ShapeSVG from '@assets/svg/shapes/shape-f.svg';
import ImageComponent from '@components/001-ImageComponent/ImageComponent.vue';
import { IRaffleSteps } from '@frontend/types/modules/raffle/IRaffle';
import RaffleService, { AnswerStatistics } from '@frontend/services/raffles/RaffleService';
import AbstractRaffle from '@modules/053-Raffle/AbstractRaffle.vue';
import CoverWaveSVG from '@modules/053-Raffle/components/welle.svg';
import IntroStep from './components/IntroStep.vue';

@Component({
	hydration: true,
	componentId: 'M053',
	components: {
		CoverWaveSVG,
		ClientOnly,
		ShapeSVG,
		ImageComponent,
		IntroStep,
		QuestionStep: () => import('./components/QuestionStep.vue'),
		FormStep: () => import('./components/FormStep.vue'),
		VoteResultStep: () => import('./components/VoteResultStep.vue'),
		ConfirmationStep: () => import('./components/ConfirmationStep.vue'),
		IncorrectStep: () => import('./components/IncorrectStep.vue')
	}
})
export default class Raffle extends AbstractRaffle<IRaffleSteps> {
	@Prop({ type: String, default: 'single' })
	protected readonly type?: 'multiple' | 'single' | 'vote' | 'formOnly';

	protected answer: string[] = [];

	protected voteResultData = {};

	protected created() {
		if (this.type === 'formOnly') {
			if (this.steps.question) {
				this.answer = this.steps.question.options.filter(item => item.correct).map(item => item.value);
			}
			this.activeStep = 'form';
		}
	}

	protected async setStepAfterAnswer(answer: string[]) {
		if (!this.raffleId) return;

		this.answer = answer;

		if (this.type === 'vote') {
			try {
				const raffleService = new RaffleService();
				const statistics = await raffleService.getStatistics(this.raffleId);

				this.voteResultData = this.generateVoteResultData(statistics);
				this.$nextTick(() => this.gotoStep('voteResult'));
			} catch (error) {
				this.gotoStep('form');
			}
		} else {
			this.gotoStep('form');
		}
	}

	protected generateVoteResultData(statistics: AnswerStatistics[]) {
		const { copy, headline, buttonLabel, statsBarColor } = this.steps.voteResult;
		return {
			headline,
			copy,
			buttonLabel,
			statsBarColor,
			list: this.steps.question.options.map(question => {
				const { label, image, value } = question;
				const match = statistics.find(item => item.answer === value);
				const share = match ? Math.round(match.share * 100) : null;
				return { label, image, share };
			})
		};
	}
}
